/**
 * 당일외 배분 분포 모니터링 (/adm/order/match/dist)
 * ($j.Pages.Admin.MatchDist / body data-page-name="MatchDist")
 *
 * 배분(MatchSplitter)은 (업종·톤수코드 · 지역그룹) 칸마다 쿼터를 소진하며 돈다.
 * 전체 합계만 보면 특정 칸이 쏠려도 안 보이므로, 칸 단위로 NS 비중과 설정 대비 편차를 본다.
 *
 *   KPI → 설정 vs 실적 → 매트릭스(톤수 × 지역그룹) → 칸 클릭 시 최근 발주 순서
 */
import Util from '../../Common/Util';
export default class MatchDist {
    initialize() {
        this.data = null;

        $('#mdReload').on('click', () => this._load());
        $('#mdDays, #mdCar').on('change', () => this._load());
        $('#mdMatrix').on('click', '.md-cell.has-data', (e) => this._openSequence($(e.currentTarget)));
        $('#mdRecent').on('click', '.md-rc', (e) => this._openMatchList($(e.currentTarget).data('o')));

        // 발주 순서 칸 클릭 — 모달은 body 직속에 그려지므로 document 에 위임한다
        $(document).off('click.mdseq').on('click.mdseq', '.md-seq-line .md-seq', (e) => {
            this._openMatchList($(e.currentTarget).data('o'));
        });

        // 알고리즘 설명 — 마우스 오버로 툴팁. 선언형(data-tip)은 클릭 트리거라 프로그래매틱으로 연다.
        $('#mdPlan')
            .on('mouseenter', '.md-algo', (e) => this._showAlgoTip(e.currentTarget))
            .on('mouseleave', '.md-algo', () => $j.Ui.Tooltip.hide());

        this._load();
    }

    /** document 에 건 위임 핸들러는 모듈이 파기될 때 같이 걷는다 */
    destroy() {
        $(document).off('click.mdseq');
    }

    async _load() {
        const q = { days: $('#mdDays').val() || 30, car_type: $('#mdCar').val() || '' };
        try {
            const r = await $.ajax({ url: '/adm/ajax/match/dist', type: 'get', data: q, dataType: 'json' });
            if (!r.ok) return;
            this.data = r;
            this._fillCarSelect(r);
            this._renderKpi(r);
            this._renderPlan(r);
            this._renderRecent(r);
            this._renderMatrix(r);
        } catch (e) {
            console.error('배분 분포 로드 실패', e);
        }
    }

    _fillCarSelect(r) {
        if (this._carFilled) return;
        this._carFilled = true;
        $('#mdCar').html((r.carTypes || []).map(v =>
            `<option value="${this._esc(v)}" ${v === r.carType ? 'selected' : ''}>${this._esc(v)}</option>`).join(''));
    }

    _renderKpi(r) {
        const k = r.kpi;
        const card = (label, value, sub, cls) => `
            <div class="ms-kpi-card ${cls || ''}">
                <div class="ms-kpi-label">${label}</div>
                <div class="ms-kpi-value">${value}</div>
                <div class="ms-kpi-sub">${sub || '&nbsp;'}</div>
            </div>`;

        $('#mdKpi').html(
            card('당일외 발주', this._n(k.total) + '<small>건</small>', `${r.carType} · 최근 ${r.days}일`) +
            card('수주율', k.wonPct + '<small>%</small>', '수주자가 정해진 비율') +
            card('평균 발송그룹', k.avgGrp + '<small>단계</small>', '많을수록 전원 발송이 느려짐') +
            card('매칭 0명', this._n(k.noMatch) + '<small>건</small>',
                 k.noMatch > 0 ? '조건에 맞는 기사가 없던 발주' : '없음',
                 k.noMatch > 0 ? 'is-warn' : '')
        );
    }

    /** 설정 비중 vs 실제 비중 — 어긋나면 배분이 의도대로 안 도는 것 */
    _renderPlan(r) {
        const rows = r.plan.map(p => {
            const dev = Math.round((p.realPct - p.planPct) * 10) / 10;
            const off = p.planPct === 0 && p.cnt > 0;          // 배분표에 없는데 실적이 있음
            const bad = Math.abs(dev) >= 10 || off;
            return `<tr class="${bad ? 'is-bad' : ''}">
                <td><span class="md-algo" data-key="${p.key}">${$j.F.Admin.MatchTag.badge(p.dt, p.ver)}
                    <i class="fas fa-question-circle"></i></span></td>
                <td class="text-center">${p.weight || '<span class="text-muted">-</span>'}</td>
                <td class="text-center">${p.planPct}%</td>
                <td class="text-center"><b>${p.realPct}%</b> <span class="text-muted">(${this._n(p.cnt)}건)</span></td>
                <td class="text-center">${off
                    ? '<span class="md-dev is-off">설정에 없음</span>'
                    : `<span class="md-dev ${Math.abs(dev) >= 10 ? 'is-bad' : (Math.abs(dev) >= 5 ? 'is-warn' : 'is-ok')}">
                         ${dev > 0 ? '+' : ''}${dev}%p</span>`}</td>
            </tr>`;
        }).join('');

        $('#mdPlan').html(`
            <h6 class="mb-2"><i class="fas fa-balance-scale"></i> 설정 vs 실적</h6>
            <table class="table table-bordered table-sm mb-1" style="max-width:640px;">
                <thead><tr>
                    <th>알고리즘</th>
                    <th style="width:44px" class="text-center">비율</th>
                    <th style="width:60px" class="text-center">설정</th>
                    <th style="width:116px" class="text-center">실제</th>
                    <th style="width:88px" class="text-center">편차</th>
                </tr></thead>
                <tbody>${rows}</tbody>
            </table>
            <div class="text-muted" style="font-size:12px">
                설정을 바꾼 직후에는 이전 설정으로 매칭된 발주가 섞여 있어 편차가 큽니다.
            </div>`);
    }

    /**
     * 최근 당일외 오더 — 업종·톤수·시도·배정(NC/NS + 세대).
     * 기간·업종 필터와 무관하게 항상 최신 20건이다(설정을 막 바꿨을 때 바로 확인하려는 목록).
     */
    _renderRecent(r) {
        const rows = (r.recent || []).map(o => {
            // 톤수는 오더의 스펙범위라 여러 개다. 첫 개만 쓰고 나머지는 "외 N" 으로 접는다.
            const tons = o.tons || [];
            const ton  = tons.length
                ? this._esc(tons[0]) + (tons.length > 1 ? ` <span class="text-muted">외 ${tons.length - 1}</span>` : '')
                : '<span class="text-muted">-</span>';
            return `<tr class="md-rc" data-o="${o.ordernum}"
                        title="오더 ${o.ordernum} · ${this._esc(o.regtime)}&#10;${this._esc((o.tons || []).join(', '))}&#10;${o.won ? '수주됨' : '수주 없음'}&#10;&#10;클릭하면 매칭현황이 열립니다">
                <td>${this._esc(o.carType)}</td>
                <td>${ton}</td>
                <td>${this._esc(o.sido) || '<span class="text-muted">-</span>'}</td>
                <td class="text-center">${$j.F.Admin.MatchTag.badge(o.dt, o.ver)}</td>
                <td class="text-center ${o.won ? '' : 'md-nowon'}">${o.won ? '수주' : '없음'}</td>
                <td class="text-center text-muted md-rt">${this._esc(o.regtime)}</td>
            </tr>`;
        }).join('');

        $('#mdRecent').html(`
            <h6 class="mb-2"><i class="fas fa-stream"></i> 최근 당일외 오더
                <span class="text-muted" style="font-size:12px;font-weight:400">— 전체 업종 최신 20건</span></h6>
            <table class="table table-bordered table-sm mb-1 md-recent">
                <thead><tr>
                    <th style="width:64px">업종</th>
                    <th>톤수</th>
                    <th style="width:64px">시도</th>
                    <th style="width:92px" class="text-center">배정</th>
                    <th style="width:56px" class="text-center">수주</th>
                    <th style="width:86px" class="text-center">발주시각</th>
                </tr></thead>
                <tbody>${rows || '<tr><td colspan="6" class="text-center text-muted">최근 당일외 오더가 없습니다.</td></tr>'}</tbody>
            </table>
            <div class="text-muted" style="font-size:12px">행을 누르면 그 오더의 매칭현황이 열립니다.</div>`);
    }

    /** 발주 순서의 칸 클릭 → 그 오더의 매칭현황(차수별 발송 목록) 팝업 */
    _openMatchList(ordernum) {
        if (!ordernum) return;
        const adr = `/adm/order/match/list?num=${ordernum}&stype=admin`;
        const w = Math.min(1400, screen.availWidth), h = Math.min(1000, screen.availHeight);
        const win = window.open(adr, 'manage_order_matchList',
            `toolbar=no,status=no,width=${w},height=${h},top=0,directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no`);
        if (win) win.focus();
    }

    /** 알고리즘 설명 툴팁 — 문구 원본은 g5_match_types(매칭설정에서 편집) */
    _showAlgoTip(el) {
        const p = (this.data.plan || []).find(x => x.key === $(el).data('key'));
        if (!p) return;

        const m = p.meta;
        const html = m
            ? `<div class="md-tip">
                   <div class="md-tip-sum">${this._esc(m.summary)}</div>
                   ${m.send_order ? `<div class="md-tip-order"><b>발송 순서</b><br>${this._esc(m.send_order)}</div>` : ''}
                   <div class="md-tip-foot">설정 비중 ${p.planPct}% · 실제 ${p.realPct}% (${this._n(p.cnt)}건)</div>
               </div>`
            : `<div class="md-tip"><div class="md-tip-sum text-muted">
                   등록된 설명이 없습니다. 매칭설정에서 이 세대의 문구를 채워주세요.</div></div>`;

        $j.Ui.Tooltip.show(el, html, {
            title: `${p.dt} ver${p.ver}${m ? ' — ' + m.label : ''}`,
            place: 'bottom',
        });
    }

    /**
     * 매트릭스 — 행=톤수코드, 열=지역그룹. 칸 색은 NS 비중이 설정 목표에서 얼마나 벗어났는지.
     * 표본이 적은 칸은 비율이 요동치므로 판정하지 않고 회색으로 둔다.
     */
    _renderMatrix(r) {
        const target = r.nsTarget;
        // 지역그룹은 묶음 전체를 보여준다. (그룹코드는 숫자라 발주 건수로 오해할 소지가 있어 표시하지 않음)
        const head = r.regions.map(g =>
            `<th class="md-rg">${this._esc(g.label)}</th>`).join('');

        const body = r.carDB.map(car => {
            const tds = r.regions.map(g => {
                const c = r.cells[`${car.code}|${g.gcode}`];
                if (!c) return `<td class="md-cell is-empty">·</td>`;

                const tot = c.nc + c.ns;
                if (tot < r.minSample) {
                    return `<td class="md-cell has-data is-few" data-code="${car.code}" data-g="${g.gcode}"
                                title="표본 ${tot}건 — 판정 보류">${tot}</td>`;
                }
                const ns  = Math.round(c.ns / tot * 1000) / 10;
                const dev = Math.abs(ns - target);
                const cls = dev < 5 ? 'is-ok' : (dev < 15 ? 'is-warn' : 'is-bad');
                const won = Math.round(c.won / tot * 100);
                return `<td class="md-cell has-data ${cls}" data-code="${car.code}" data-g="${g.gcode}"
                            title="${this._esc(car.eng_name)} · ${this._esc(g.label)}&#10;NC ${c.nc} / NS ${c.ns} (NS ${ns}%, 목표 ${target}%)&#10;수주율 ${won}%">
                            <b>${ns}%</b><span class="md-cnt">${tot}</span>
                        </td>`;
            }).join('');
            return `<tr><th class="md-rowhead">${this._esc(car.eng_name)}</th>${tds}</tr>`;
        }).join('');

        $('#mdMatrix').html(`
            <h6 class="mb-2"><i class="fas fa-th"></i> 톤수 × 지역그룹 — NS 비중</h6>
            <div class="md-legend">
                <span>목표 <b>${target}%</b></span>
                <span><i class="is-ok"></i>±5%p</span>
                <span><i class="is-warn"></i>±15%p</span>
                <span><i class="is-bad"></i>그 이상</span>
                <span><i class="is-few"></i>표본 ${r.minSample}건 미만</span>
                <span class="text-muted ml-auto">칸을 누르면 그 칸의 최근 발주 순서</span>
            </div>
            <div class="md-wrap">
                <table class="md-matrix">
                    <thead><tr><th class="md-rowhead">톤수</th>${head}</tr></thead>
                    <tbody>${body}</tbody>
                </table>
            </div>`);
    }

    /** 칸의 최근 발주 순서 — 쿼터가 실제로 NC…NC NS 로 도는지 확인 */
    async _openSequence($td) {
        const code  = $td.data('code');
        const gcode = $td.data('g');
        const car   = this.data.carType;
        const carNm = (this.data.carDB.find(c => String(c.code) === String(code)) || {}).eng_name || code;
        const rgNm  = (this.data.regions.find(g => String(g.gcode) === String(gcode)) || {}).label || gcode;

        try {
            const r = await $.ajax({
                url: '/adm/ajax/match/dist/sequence', type: 'get', dataType: 'json',
                data: { car_type: car, code, gcode },
            });
            const rows = (r && r.rows) || [];

            const T = $j.F.Admin.MatchTag;
            const seq = rows.map(o =>
                `<span class="md-seq mcell ${T.cls(o.dt)} ${o.won ? '' : 'no-won'}"
                       data-o="${o.ordernum}"
                       title="오더 ${o.ordernum}&#10;${T.text(o.dt, o.ver)} · ${this._esc(o.sido || '')}&#10;${o.regtime}&#10;${o.won ? '수주됨' : '수주 없음'}&#10;&#10;클릭하면 매칭현황이 열립니다">${T.code(o.dt, o.ver)}</span>`
            ).join('');

            $j.Ui.JBModal.html('md-seq-modal',
                `<div class="md-seq-box">
                    <div class="md-seq-head">${this._esc(car)} ${this._esc(carNm)} · ${this._esc(rgNm)}
                        <span class="text-muted">— 오래된 발주(왼쪽) → 최신(오른쪽), 총 ${rows.length}건</span></div>
                    <div class="md-seq-line">${seq || '<span class="text-muted">발주 이력이 없습니다.</span>'}</div>
                    <div class="md-seq-legend">
                        <span><i class="is-nc"></i>NC 일반</span>
                        <span><i class="is-ns"></i>NS 미수주자용</span>
                        <span><i class="no-won"></i>수주 없음(테두리 점선)</span>
                    </div>
                    <div class="text-muted mt-2" style="font-size:12px">
                        설정 비율대로라면 이 줄에서 NS 가 일정 간격으로 섞여 나타나야 합니다.
                        칸을 누르면 그 오더의 <b>매칭현황</b>(차수별 발송 목록)이 열립니다.
                    </div>
                </div>`,
                '칸별 발주 순서', { width: '1120px' });   // 40칸이 한 줄에 들어가는 폭
        } catch (e) {
            console.error('시퀀스 로드 실패', e);
            Util.swalert('발주 순서를 불러오지 못했습니다.');
        }
    }

    _n(v)   { return Number(v ?? 0).toLocaleString(); }
    _esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }
}
